import { z } from "zod";

import { type UserImageMedia, UserImageMediaSchema } from "./image";

import { UserOnboardingStage } from "@/utils/onboarding";

export enum UserUnlockingStage {
  /*
    Tracks the user's current position in the app unlocking flow.

    Each stage represents the step the user is currently engaged with
    as features are progressively unlocked. The value reflects where
    the user is in the flow, not which stages have been completed.
  */
  ON_STAGE_ONE = "ON_STAGE_ONE", // Avatar and background image
  ON_STAGE_TWO = "ON_STAGE_TWO", // Profile details and public images
  ON_STAGE_THREE = "ON_STAGE_THREE", // Subscription
  ON_STAGE_FOUR = "ON_STAGE_FOUR", // Active subscription
}

export type UserIdentity = {
  username: string;
  avatar: UserImageMedia | null;
  streamToken: string;
  pushToken: string | null;
  unreadNotificationsCount: number;
  privateAlbumnRequestsCount: number;
  onboardingStage: UserOnboardingStage;
  unlockingStage: UserUnlockingStage;
};

export type DeleteAccountRequest = {
  email: string;
  password: string;
  reason_id: string;
  user_feedback: string;
};

export type SetOnboardingStageRequest = {
  stage: UserOnboardingStage;
};

export const UserIdentitySchema = z.object({
  username: z.string(),
  avatar: UserImageMediaSchema.nullable(),
  streamToken: z.string(),
  pushToken: z.nullable(z.string()),
  unreadNotificationsCount: z.number(),
  privateAlbumnRequestsCount: z.number(),
  onboardingStage: z.nativeEnum(UserOnboardingStage),
  unlockingStage: z.nativeEnum(UserUnlockingStage),
});
